<template>
  <div>
    <sweet-modal blocking :title="isCreate ? 'Add Open Balance Inventory' : 'Edit Open Balance Inventory'" ref="modal" class="modal" v-on:close="closeModal('form')">
      <el-form :model="form" :disabled="onlyInfo" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">

        <el-row :gutter="20">
          <el-col :span="8" :offset="0">
            <el-form-item prop="warehouseId">
              <el-select v-model="form.warehouseId" placeholder="Warehouse" filterable style="width: 100%">
                <el-option v-for="item in warehouseList"
                  :key="item.id"
                  :label="item.warehouseName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-form-item prop="date">
              <el-date-picker
                v-model="form.date"
                :clearable='false'
                style="width: 100%;"
                type="date"
                format="d MMM yy"
                value-format="MM-dd-yyyy"
                placeholder="Date">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-form-item prop="referenceNo">
              <el-input label="Reference No" v-model.trim="form.referenceNo" maxlength="10" show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" :offset="0">
            <el-form-item prop="currency">
              <el-select v-model="form.currency" placeholder="Currency" filterable style="width: 100%">
                <el-option v-for="item in currencyList"
                  :key="item.id"
                  :label="item.code"
                  :value="item.code"
                  @click.native="changeCurrency(item)">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="0">
            <el-form-item label-width="120px" label="Exchange Rate" prop="fxRate">
              <el-row :gutter="10">
                <el-col :span="9" :offset="0">
                  <money
                    v-model="form.fxRate"
                    v-bind="moneyRate"
                    :readonly="currencyCompany.code === form.currency"
                    style="text-align: right;"></money>
                </el-col>
                <el-col :span="5" :offset="0">
                  <el-tag type="info" v-html="currencyCompany.code"></el-tag>
                </el-col>
                <!-- <el-col :span="9" :offset="0">
                  <div style="text-align: right;">{{ totalForRate }}</div>
                </el-col> -->
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>

        <div style="margin-bottom: 10px;">Note: All Items Exclusive of Tax</div>

        <el-table
          :data="tableData"
          size="mini"
          border
          style="margin-bottom: 10px; width: 100%;">
          <el-table-column
            label="Item Code">
            <template slot-scope="scope">
              <el-select v-model="scope.row.code" filterable size="mini" placeholder="Select" style="width:100%">
                <el-option v-for="item in items"
                  :key="item.id"
                  :label="item.code"
                  :value="item.code"
                  @click.native="selectItemCode(item, scope.row)">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="Item Name">
            <template slot-scope="scope">
              <el-select v-model="scope.row.name" filterable size="mini" placeholder="Select" style="width:100%">
                <el-option v-for="item in items"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                  @click.native="selectItemName(item, scope.row)">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="Description"
            align="center">
            <template slot-scope="scope">
              <el-popover
                v-if="scope.row.description"
                placement="top"
                title="Description"
                width="400"
                trigger="click"
                :content="scope.row.description">
                <el-button size="mini" slot="reference" icon="el-icon-view"></el-button>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            label="Cost"
            align="right">
            <template slot-scope="scope">
              <div v-text="formatPrice(scope.row.purchasePrice)"></div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="Sell"
            align="right">
            <template slot-scope="scope">
              <div v-if="scope.row.sellPrice" v-text="formatPrice(scope.row.sellPrice)"></div>
            </template>
          </el-table-column> -->
          <el-table-column
            label="QTY"
            align="center"
            width="70">
            <template slot-scope="scope">
              <el-input placeholder="Qty" type="number" v-model="scope.row.count" size="mini" @input="countTotal(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="unitName"
            label="UoM"
            align="center">
          </el-table-column>
          <el-table-column
            label="Total Cost"
            align="right">
            <template slot-scope="scope">
              <div v-text="formatPrice(scope.row.purchaseTotal)"></div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="Total Sell"
            align="right">
            <template slot-scope="scope">
              <div v-text="formatPrice(scope.row.sellTotal)"></div>
            </template>
          </el-table-column> -->
          <el-table-column
            label="Vendor">
            <template slot-scope="scope">
              <el-select v-model="scope.row.vendorId" :disabled="true" filterable clearable size="mini" placeholder="Select" style="width:100%">
                <el-option v-for="item in vendorList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="Action"
            align="left"
            width="151">
            <template slot-scope="scope">
              <div>
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  @click="addNewItem(scope.$index, scope.row)">Add line</el-button>
                <el-button
                  v-if="scope.$index !== 0"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  plain
                  @click="removeItem(scope.$index, scope.row)"></el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="total">
          <div class="total__purchase">{{ formatPrice(purchaseTotal) }}</div>
          <!-- <div class="total__sell">{{ formatPrice(sellTotal) }}</div> -->
        </div>

        <el-form-item prop="description">
          <el-input label="Description" type="textarea" v-model="form.description" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <el-form-item v-if="!onlyInfo">
          <div class="btn__flex-end">
            <div v-if="isCreate">
              <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
              <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
            </div>
            <div v-else>
              <el-button @click="modalCancel('modal')">{{$t('general_cancel')}}</el-button>
              <el-button @click="editItem('form')" type="primary">{{$t('general_submit')}}</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </sweet-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import {Money} from 'v-money'
  let moment = require('moment')
  const FASTFOREX_API_KEY = process.env.VUE_APP_FASTFOREX_API_KEY

  export default {
    name: 'create-update-modal',
    components: {
      SweetModal,
      Money,
    },
    data() {
      return {
        moment:moment,
        isCreate: true,
        row: null,
        onlyInfo: false,

        moneyRate: {
          precision: 5,
          decimal: '.',
          thousands: ',',
          masked: false
        },

        // itemsList: [],
        vendorList: [],
        warehouseList: [],
        currencyList: [],
        currencyCompany: {},
        form: {
          warehouseId: null,
          date: moment().format("MM-DD-YYYY"),
          referenceNo: null,
          description: null,
          currency: null,
          fxRate: 1,
        },

        items: [],
        purchaseTotal: 0,
        // sellTotal: 0,
        tableData: [
          {
            itemId: null,
            code:null,
            name:null,
            description: null,
            purchasePrice: 0,
            // sellPrice: 0,
            count: 1,
            unitName: null,
            purchaseTotal: 0,
            // sellTotal: 0,
            vendorId: null,
            accountId: null,
          },
        ],

        rules: {
          warehouseId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          date: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          currency: [
            { required: true, message: 'Please pick a exchange rate', trigger: 'blur' }
          ],
        },
      }
    },
    watch: {
      tableData: {
        handler(newVal, oldVal) {
          this.purchaseTotal = 0
          // this.sellTotal = 0
          newVal.forEach((element) => {
            this.purchaseTotal += element.purchaseTotal
            // this.sellTotal += element.sellTotal
          });
          this.form.costPrice = this.purchaseTotal
          // this.form.sellPrice = this.sellTotal
        },
        deep: true
      },
      'form.date': function (val) {
        if (this.currencyCompany.code == this.form.currency) {
          this.form.fxRate = 1
        } else {
          if (this.form.currency === null) return
          if (moment(new Date()).format("YYYY-MM-DD") == moment(this.form.date, 'MM-DD-YYYY').format("YYYY-MM-DD")) {
            console.log(`[FastForex Request] URL: https://api.fastforex.io/fetch-one?from=${this.form.currency}&to=${this.currencyCompany.code}&api_key=${FASTFOREX_API_KEY}`);
            axios
            .get(`https://api.fastforex.io/fetch-one?from=${this.form.currency}&to=${this.currencyCompany.code}&api_key=${FASTFOREX_API_KEY}`)
            .then(response => {
              this.form.fxRate = response.data.result[this.currencyCompany.code]
              // eslint-disable-next-line no-console
              console.log('response', response.data.results)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
          } else if (moment(this.form.date, 'MM-DD-YYYY').format("x") > moment(new Date()).format("x")) {
            this.form.fxRate = 1
          } else {
            console.log(`[FastForex Historical Request] URL: https://api.fastforex.io/historical?date=${ moment(this.form.date, 'MM-DD-YYYY').format("YYYY-MM-DD") }&from=${this.form.currency}&to=${this.currencyCompany.code}&api_key=${FASTFOREX_API_KEY}`);
            axios
            .get(`https://api.fastforex.io/historical?date=${ moment(this.form.date, 'MM-DD-YYYY').format("YYYY-MM-DD") }&from=${this.form.currency}&to=${this.currencyCompany.code}&api_key=${FASTFOREX_API_KEY}`)
            .then(response => {
              this.form.fxRate = response.data.results[this.currencyCompany.code]
              // eslint-disable-next-line no-console
              console.log('response', response.data.results)
            })
            .catch(error => {
              if (error.response.data.error === 'Historical data limited to 150 days') {
                this.notification("Notification", error.response.data.error, "info")
              }
              console.log('An error occurred:', error);
            });
          }

        }
      }
    },
    computed:{
      totalForRate() {
        return this.formatPrice(0)
        // return this.formatPrice(this.form.fxRate * this.countTotalDebit(this.form.items))
      },
      companyLayout() {
        return this.$store.state.companyLayout
      },
    },
    methods: {
      setTitle() {
        if (this.onlyInfo) {
          this.title = 'Open Balance Inventory Details'
        } else {
          this.title = this.isCreate ? 'Add Open Balance Inventory' : 'Edit Open Balance Inventory'
        }
      },
      async openModal({ isCreate = true, row = {}, onlyInfo = false }) {
        this.onlyInfo = onlyInfo
        this.isCreate = isCreate
        this.setTitle()
        this.row = row
        await this.directories()
        if (!isCreate) {
          await this.handleEdit()
        }
        this.$refs.modal.open()
      },
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      closeModal(ref){
        this.$refs[ref].resetFields()
        this.tableData = [
          {
            itemId: null,
            code:null,
            name:null,
            description: null,
            purchasePrice: 0,
            // sellPrice: 0,
            count: 1,
            unitName: null,
            purchaseTotal: 0,
            // sellTotal: 0,
            vendorId: null,
            accountId: null,
          }
        ]
      },
      async directories() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items/openBalance/directories?companyId=${this.$route.query.companyId}&currencyId=${this.companyLayout.currency.id}`)
          this.items = data.directories.itemsList
          this.currencyList = data.directories.currencyList
          this.warehouseList = data.directories.warehouseList

          this.form.currency = data.directories.currencyCompany[0].code
          this.currencyCompany.id = data.directories.currencyCompany[0].id
          this.currencyCompany.code = data.directories.currencyCompany[0].code
          this.currencyCompany.name = data.directories.currencyCompany[0].name
          await this.setVendors()
          this.$refs.modal.open()
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      getCurrencyId() {
        let currencyId = null
        this.currencyList.forEach(element => {
          if (element.code == this.form.currency) currencyId = element.id
        })
        return currencyId
      },
      async getItemListForCurrency() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
          const { data } = await axios.get(`/api/v1/items/openBalance/directories?companyId=${this.$route.query.companyId}&currencyId=${this.getCurrencyId()}`)
          this.items = data.directories.itemsList
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      addItem(form){
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            let loader = this.$loading.show();
            let arr = []
            for (let i = 0; i < this.tableData.length; i++) {
              arr.push({
                qty: +this.tableData[i].count,
                costPrice: this.tableData[i].purchasePrice,
                itemId: this.tableData[i].itemId,
                accountId: this.tableData[i].accountId,
                vendorId: this.tableData[i].vendorId,
                description: this.tableData[i].description,
              })
            }
            try {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.post(`/api/v1/items/openBalance?companyId=${this.$route.query.companyId}`, {
                description: this.form.description,
                referenceNo: this.form.referenceNo,
                warehouseId: this.form.warehouseId,
                date: this.form.date,
                fxRate: this.form.fxRate,
                currency: this.form.currency,
                totalAmount: this.purchaseTotal,
                itemsOBDList: arr
              })
              this.$refs.modal.close()
              this.$emit('loadList')
              loader.hide()
            } catch (error) {
              console.log('An error occurred:', error);
              loader.hide()
            }
          } else {
            console.log('Error valid!');
            return false;
          }
        });
      },
      async handleEdit() {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.get(`/api/v1/items/openBalance?id=${this.row.id}`)
          for (const key in this.form) {
            this.form[key] = data.item[key]
          }
          this.tableData = data.item.itemsOBDList
          this.$refs.modal.open()
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      editItem(form){
        this.$refs[form].validate(async (valid) => {
          if (valid) {
            let loader = this.$loading.show();
            let arr = []
            for (let i = 0; i < this.tableData.length; i++) {
              arr.push({
                qty: +this.tableData[i].count,
                costPrice: this.tableData[i].purchasePrice,
                itemId: this.tableData[i].itemId,
                accountId: this.tableData[i].accountId,
                vendorId: this.tableData[i].vendorId,
                description: this.tableData[i].description,
              })
            }
            try {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              await axios.put(`/api/v1/items/openBalance?companyId=${this.$route.query.companyId}&id=${this.row.id}`, {
                description: this.form.description,
                referenceNo: this.form.referenceNo,
                warehouseId: this.form.warehouseId,
                date: this.form.date,
                fxRate: this.form.fxRate,
                currency: this.form.currency,
                totalAmount: this.purchaseTotal,
                itemsOBDList: arr
              })
              this.$refs.modal.close()
              this.$emit('loadList')
              loader.hide()
            } catch (error) {
              console.log('An error occurred:', error);
              loader.hide()
            }
          } else {
            console.log('Error valid!');
            return false;
          }
        });
      },
      async setVendors() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString()
        const { data } = await axios.get(`/api/v1/client-vendor/list?type=vendor&companyId=${this.$route.query.companyId}&currencyId=${this.getCurrencyId()}`)
        this.vendorList = data.list
      },
      async clearTableData() {
        this.tableData = [
          {
            itemId: null,
            code:null,
            name:null,
            description: null,
            purchasePrice: 0,
            // sellPrice: 0,
            count: 1,
            unitName: null,
            purchaseTotal: 0,
            // sellTotal: 0,
            vendorId: null,
            accountId: null,
          },
        ]
      },
      async changeCurrency(item) {
        await this.clearTableData()
        await this.getItemListForCurrency()
        await this.setVendors()
        if (this.currencyCompany.id == item.id) {
          this.form.fxRate = 1
        } else {
          if (moment(new Date()).format("YYYY-MM-DD") == moment(this.form.date, 'MM-DD-YYYY').format("YYYY-MM-DD")) {
            console.log(`[FastForex Request] URL: https://api.fastforex.io/fetch-one?from=${item.code}&to=${this.currencyCompany.code}&api_key=${FASTFOREX_API_KEY}`);
            new Promise((resolve) => {
              resolve({
                data: {
                  result: {
                    [this.currencyCompany.code]: 1
                  }
                }
              })
            })
            .then(response => {
              this.form.fxRate = response.data.result[this.currencyCompany.code]
              // eslint-disable-next-line no-console
              console.log('response', response.data.results)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
          } else if (moment(this.form.date, 'MM-DD-YYYY').format("x") > moment(new Date()).format("x")) {
            this.form.fxRate = 1
          } else {
            console.log(`[FastForex Historical Request] URL: https://api.fastforex.io/historical?date=${ moment(this.form.date, 'MM-DD-YYYY').format("YYYY-MM-DD") }&from=${item.code}&to=${this.currencyCompany.code}&api_key=${FASTFOREX_API_KEY}`);
            new Promise((resolve) => {
              resolve({
                data: {
                  results: {
                    [this.currencyCompany.code]: 1
                  }
                }
              })
            })
            .then(response => {
              this.form.fxRate = response.data.results[this.currencyCompany.code]
              // eslint-disable-next-line no-console
              console.log('response', response.data.results)
            })
            .catch(error => {
              if (error.response && error.response.data && error.response.data.error === 'Historical data limited to 150 days') {
                this.notification("Notification", error.response.data.error, "info")
              }
              console.log('An error occurred:', error);
            });
          }
        }
      },
      removeItem(index, row) {
        this.tableData = this.tableData.filter((_, i) => i !== index);
      },
      selectItemCode(item, row) {
        if (this.tableData.some(element => element.itemId === item.itemId)) {
          row.itemId = null
          row.code = null
          row.name = null
          row.description = null
          row.purchasePrice = 0
          // row.sellPrice = 0
          row.count = 1
          row.unitName = null
          row.purchaseTotal = 0
          // row.sellTotal = 0
          row.vendorId = null
          row.accountId = null
          return
        }

        row.name = item.name
        row.itemId = item.itemId
        row.description = item.description
        row.purchasePrice = item.purchasePrice
        // row.sellPrice = item.sellPrice
        row.unitName = item.unitName
        row.count = 1
        row.purchaseTotal = item.purchasePrice
        // row.sellTotal = item.sellPrice
        row.accountId = item.accountId
        row.vendorId = item.vendorId
        return row
      },
      selectItemName(item, row) {
        if (this.tableData.some(element => element.itemId === item.itemId)) {
          row.itemId = null
          row.code = null
          row.name = null
          row.description = null
          row.purchasePrice = 0
          // row.sellPrice = 0
          row.count = 1
          row.unitName = null
          row.purchaseTotal = 0
          // row.sellTotal = 0
          row.vendorId = null
          row.accountId = null
          return
        }

        row.code = item.code
        row.itemId = item.itemId
        row.description = item.description
        row.purchasePrice = item.purchasePrice
        // row.sellPrice = item.sellPrice
        row.unitName = item.unitName
        row.count = 1
        row.purchaseTotal = item.purchasePrice
        // row.sellTotal = item.sellPrice
        row.accountId = item.accountId
        row.vendorId = item.vendorId
        return row
      },
      addNewItem(index, row) {
        const item = {
          itemId: null,
          code:null,
          name:null,
          description: null,
          purchasePrice: 0,
          // sellPrice: 0,
          count: 1,
          unitName: null,
          purchaseTotal: 0,
          // sellTotal: 0,
          vendorId: null,
          accountId: null,
        }

        this.tableData.push(item)
        return row
      },
      countTotal(row) {
        if (row.count) {
          row.purchaseTotal = row.count * row.purchasePrice
          // row.sellTotal = row.count * row.sellPrice
        } else {
          row.purchaseTotal = 0
          // row.sellTotal = 0
        }
      },
      isDisabled(itemId) {
        // const foundItem = this.items.find(item => item.itemId === itemId)
        // return foundItem ? true : false
        // return this.tableData.some(item => item.itemId === itemId)
        return false
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
.total {
  font-size: 12px;
  margin-bottom: 20px;
  padding-left: 595px;
  &__purchase {
    text-align: right;
    padding: 0 10px;
    width: 89px;
    display:inline-block;
    width: 89px;
  }
  &__sell {
    text-align: right;
    padding: 0 10px;
    width: 89px;
    display:inline-block;
    width: 89px;
  }
}

/deep/.v-money {
  height: 28px;
  line-height: 28px;
  -webkit-appearance: none;
  background-color: transparent;
  background-image: none;
  border: none;
  border-bottom: 2px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px 0 0;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}
</style>